"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useGrammars;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useGrammars() {
  return [(0, _useWebChatAPIContext.default)().grammars];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VHcmFtbWFycy50cyJdLCJuYW1lcyI6WyJ1c2VHcmFtbWFycyIsImdyYW1tYXJzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxXQUFULEdBQThCO0FBQzNDLFNBQU8sQ0FBQyxxQ0FBdUJDLFFBQXhCLENBQVA7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZVdlYkNoYXRBUElDb250ZXh0IGZyb20gJy4vaW50ZXJuYWwvdXNlV2ViQ2hhdEFQSUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VHcmFtbWFycygpOiBbYW55XSB7XG4gIHJldHVybiBbdXNlV2ViQ2hhdEFQSUNvbnRleHQoKS5ncmFtbWFyc107XG59XG4iXX0=